'use client';

import { useEffect, useRef } from 'react';
import Script from 'next/script';
import { usePathname, useSearchParams } from 'next/navigation';

const GA_MEASUREMENT_ID = 'G-7R3M559JE8';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

type GoogleAnalyticsProps = {
  nonce?: string;
};

export default function GoogleAnalytics({ nonce }: GoogleAnalyticsProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hasTrackedInitialPageView = useRef(false);

  useEffect(() => {
    if (!hasTrackedInitialPageView.current) {
      hasTrackedInitialPageView.current = true;
      return;
    }

    const gtag = window.gtag;
    if (!gtag || !pathname) return;

    const queryString = searchParams.toString();
    const pagePath = queryString ? `${pathname}?${queryString}` : pathname;

    gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
    });
  }, [pathname, searchParams]);

  return (
    <>
      <Script data-component-id="src/app/components/GoogleAnalytics.tsx:44:6" data-component-path="src/app/components/GoogleAnalytics.tsx" data-component-line="44" data-component-end-line="50" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics-src%22%7D"
        id="google-analytics-src"
        async
        nonce={nonce}
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script data-component-id="src/app/components/GoogleAnalytics.tsx:51:6" data-component-path="src/app/components/GoogleAnalytics.tsx" data-component-line="51" data-component-end-line="59" data-component-file="GoogleAnalytics.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22id%22%3A%22google-analytics-init%22%7D" id="google-analytics-init" nonce={nonce} strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          window.gtag = gtag;
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
